import React from 'react';

/** Ethereum-style diamond (replaces ⟠ emoji in marketing cards). */
export function IconEvmDiamond({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={22}
      height={22}
      fill="currentColor"
      aria-hidden
    >
      <path d="M12 2l10 10-10 10L2 12 12 2zm0 4.2L6.4 12 12 17.8 17.6 12 12 6.2z" />
    </svg>
  );
}

/** Gas pump outline (replaces ⛽ emoji). */
export function IconGasPump({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={22}
      height={22}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M4 22V8a2 2 0 012-2h6a2 2 0 012 2v14H4zM6 6V4a2 2 0 012-2h2a2 2 0 012 2v2" />
      <path d="M14 12h2a2 2 0 012 2v3a2 2 0 01-2 2h-2" />
      <path d="M18 10V8" />
      <path d="M8 18h4" />
    </svg>
  );
}
